import { SearchResult } from '../../apis/restaurant-api/merchant-admin/venue-search/types';

export const getSlugOrId = (result?: SearchResult): string | null => {
  if (!result || !result.value) {
    return null;
  }
  if (result.type === 'venue') {
    return result.value.slug;
  }

  if (result.type === 'merchant') {
    return result.value.itemid.$oid;
  }
  if (result.type === 'enterprise' || result.type === 'brand') {
    return result.value.id;
  }
  return null;
};

export const getResultTitle = (result: SearchResult) => {
  if (result.type === 'enterprise' || result.type === 'brand') {
    return result.value.name;
  }
  return result.value.name[0].value;
};

export const getResultSubtitle = (result: SearchResult) => {
  switch (result.type) {
    case 'venue':
      return result.value.address;
    default:
      return null;
  }
};
